(() => {
    const initVariantSelectors = (scope = document) => {
      scope.querySelectorAll('[data-main-product-v2-variant-selector]').forEach((selector) => {
        if (selector.dataset.mainProductV2VariantBound === 'true') return;

        const variantData = selector.querySelector('[data-main-product-v2-variants]');
        const productInfo = selector.closest('product-info');
        const optionIndex = Number(selector.dataset.optionIndex || 0);
        let variants = [];

        try {
          variants = JSON.parse(variantData?.textContent || '[]');
        } catch (error) {
          return;
        }

        const selectVariant = (button) => {
          const currentVariant = variants.find((variant) => String(variant.id) === selector.dataset.selectedVariantId) || variants[0];
          if (!currentVariant) return;

          const selectedOptions = [...currentVariant.options];
          selectedOptions[optionIndex] = button.dataset.mainProductV2VariantValue;
          const nextVariant = variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]));
          if (!nextVariant) return;

          selector.dataset.selectedVariantId = nextVariant.id;
          selector.querySelectorAll('[data-main-product-v2-variant-value]').forEach((item) => {
            const isSelected = item === button;
            item.classList.toggle('main_product_v2__variant-selector-option--selected', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });
          const badge = selector.querySelector('.main_product_v2__variant-selector-badge');
          const firstOption = selector.querySelector('[data-main-product-v2-variant-value]');
          badge?.classList.toggle('main_product_v2__variant-selector-badge--active', button !== firstOption);

          productInfo?.querySelectorAll('input[name="id"]').forEach((input) => {
            input.value = nextVariant.id;
            input.disabled = !nextVariant.available;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: productInfo?.dataset.section,
                variant: nextVariant
              }
            });
          }

          selector.dispatchEvent(new CustomEvent('main-product-v2:variant-change', { bubbles: true, detail: { variant: nextVariant } }));
        };

        selector.querySelectorAll('[data-main-product-v2-variant-value]').forEach((button) => {
          button.addEventListener('click', () => selectVariant(button));
        });
        const badge = selector.querySelector('.main_product_v2__variant-selector-badge');
        const firstOption = selector.querySelector('[data-main-product-v2-variant-value]');
        const selectedOption = selector.querySelector('.main_product_v2__variant-selector-option--selected');
        badge?.classList.toggle('main_product_v2__variant-selector-badge--active', Boolean(selectedOption && selectedOption !== firstOption));
        selector.dataset.mainProductV2VariantBound = 'true';
      });
    };

    const start = () => initVariantSelectors();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();

    if (!window.__mainProductV2VariantSelectorEditorEventsBound) {
      window.__mainProductV2VariantSelectorEditorEventsBound = true;
      document.addEventListener('shopify:section:load', (event) => initVariantSelectors(event.target));
    }
  })();
